import React from "react";
import "./smallModal.css";
import SmallModalEdit, {
  EditFormData,
} from "../fluxo-tax/smallModalEdit/smallModalEdit";

interface EditModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: EditFormData) => void;
  mode: "create" | "edit";
  initialData?: EditFormData;
  isSubmitting: boolean;
  onDisableButton?: (disabled: boolean) => void;
  isButtonDisabled: boolean;
  isAssociated?: boolean;
}

function getModalTitle(mode:"create" | "edit", isAssociated: boolean ){
  if(mode == "edit") return "Editar Aprovador"
  if(isAssociated) return "Cadastrar Associado";
  return "Cadastrar Aprovador";
}

export const EditModal: React.FC<EditModalProps> = ({
  open,
  onClose,
  onConfirm,
  mode,
  initialData,
  isSubmitting,
  onDisableButton,
  isButtonDisabled,
  isAssociated = false,
}) => {

  return (
    <SmallModalEdit
      titleModal={getModalTitle(mode, isAssociated)}
      mode={mode}
      initialData={initialData}
      onConfirm={onConfirm}
      isButtonDisabled={isButtonDisabled}
      onClose={onClose}
      isSubmitting={isSubmitting}
      onDisableButton={onDisableButton}
      className="eidtModal"
      isAssociated={isAssociated}
    />
  );
};
